(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("PeerSoxClient", [], factory);
	else if(typeof exports === 'object')
		exports["PeerSoxClient"] = factory();
	else
		root["PeerSoxClient"] = factory();
})(window, function() {
return 